module.exports = __webpack_public_path__ + "img/c03_unitswanshipchampion_Normal_ua.b5176574.webp";